var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDontWantToLearn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.25C3.5 1.83579 3.16421 1.5 2.75 1.5C2.33579 1.5 2 1.83579 2 2.25V13.75C2 14.1642 2.33579 14.5 2.75 14.5C3.16421 14.5 3.5 14.1642 3.5 13.75V2.25Z",
    fill: "#54687D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.17482V8.76743C4.5 9.11956 4.85428 9.36137 5.1822 9.23305L14.6591 5.52471C15.1007 5.3519 15.0761 4.71882 14.6225 4.58075L5.14558 1.69648C4.82436 1.59872 4.5 1.83905 4.5 2.17482Z",
    fill: "#54687D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDontWantToLearn);
export default __webpack_public_path__ + "static/media/dont-want-to-learn.ebd49c3435983e8174b6108d6f78f1df.svg";
export { ForwardRef as ReactComponent };